







































import {
  EventManagementEventItemDTO,
  EventManagementEventService as eventApi,
} from "@/common/api";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const eventX = namespace("Event");

@Component({
  name: "EventSettingPrintComponent",
  components: {},
})
export default class EventSettingPrintComponent extends Vue {
  public eventItems = [] as EventManagementEventItemDTO[];
  public eventId = null as number | null;

  public title = "";

  public init = true;

  @eventX.Action
  public updateEventItems!: (items) => void;

  public async created() {
    this.eventId = Number(this.$router.currentRoute.params.id);
    if (this.eventId) {
      this.getListItem();
      const { data } = await eventApi.adminEventPrintResultItemList({
        event_id: this.eventId,
        mode: this.$router.currentRoute.query.mode as string,
      });
      this.updateEventItems(data.event_items);
    }
    this.eventItems = store.state.Event.items;

    this.init = false;
  }

  public mounted() {
    let base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/paper.css");
    document.querySelector("head").append(base);

    base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/pdf.css");
    document.querySelector("head").append(base);
  }

  get pagedItems() {
    // 12件ごとに分割
    const pageSize = 12;
    const pages = [];
    for (let int = 0; int < this.eventItems.length; int += pageSize) {
      pages.push(this.eventItems.slice(int, int + pageSize));
    }
    return pages;
  }

  private async getListItem() {
    const result = await eventApi.adminEventView({
      id: this.eventId,
    });
    this.title = result.data.event.title;
  }
}
